import { ApiEndpointClient } from './resource-client';
const CUSTOMER_API_PREFIX = 'customer-api/v1';
export class CustomersClient extends ApiEndpointClient {
    constructor(http) {
        super(http, CUSTOMER_API_PREFIX);
    }
    getAppraiserCustomer = async ({ customerId }, options) => {
        return this.get(`/customers/${customerId}`, { response: 'content-type-or-empty', signal: options?.signal });
    };
    getAppraiserCustomers = async (options) => {
        return this.get('/customers/', { response: 'content-type-or-empty', signal: options?.signal });
    };
    createCustomer = async (newCustomer) => {
        return this.post('/customers/', { response: 'content-type-or-empty', json: newCustomer });
    };
    uploadCompanyImage = async ({ customerId, image }) => {
        const formData = new FormData();
        formData.append('file', image);
        return this.post(`/customers/${customerId}/company-picture`, {
            body: formData,
            response: 'content-type-or-empty',
        });
    };
    patchAppraiserCustomer = async ({ customerId, operations, }) => {
        await this.patch(`/internal-customers/${customerId}`, { json: operations, response: 'raw' });
    };
    getCustomer = async ({ customerId }) => {
        return this.get(`/customers/${customerId}`);
    };
    getCustomers = async ({ customerUuid } = {}) => {
        return this.get('/customers', {
            response: 'content-type',
            query: customerUuid ? { customer_uuid: customerUuid } : undefined,
        });
    };
    patchCustomer = async ({ customerId, operations, customerUuid, }) => {
        await this.patch(`/customers/${customerId}`, {
            json: operations,
            query: customerUuid ? { customer_uuid: customerUuid } : undefined,
            response: 'raw',
        });
    };
}
